module.exports = __webpack_public_path__ + "static/talks-hero-image@2x-14b420d02db8af9a6c314fbdf8ee6617.jpg";